/* import __COLOCATED_TEMPLATE__ from './paired-device-icon.hbs.js'; */
import Component from '@ember/component';
export default class PairedDeviceIcon extends Component {}